export default "__VITE_ASSET__qlN9WdjW__"